import { Component } from '@angular/core';

@Component({
  selector: 'empathy-multi-choice-description',
  templateUrl: 'multi-choice-description.component.html',
  styleUrls: ['./multi-choice-description.component.scss']
})
export class MultiChoiceDescriptionComponent {}
